import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-zewotherm-lightgrey min-h-52 rounded-lg w-full flex flex-col items-center p-2" }
const _hoisted_2 = { class: "w-full flex justify-between" }
const _hoisted_3 = { class: "text-sm text-left font-bold" }
const _hoisted_4 = { class: "text-sm text-rigth font-bold" }
const _hoisted_5 = { class: "flex mt-2 flex-col gap-1 w-full" }


import SwiperDivLabelAndValueDiv from './SwiperDivLabelAndValueDiv.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SwiperDiv',
  props: {
    titleStart: null,
    titleEnd: null,
    address: null,
    city: null,
    phone: null,
    mobilePhone: null,
    email: null,
    fax: null
  },
  setup(__props: any) {

const props = __props as {
  titleStart: string
  titleEnd: string
  address?: string
  city?: string
  phone?: string
  mobilePhone?: string
  email?: string
  fax?: string
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, _toDisplayString(props.titleStart), 1),
      _createElementVNode("label", _hoisted_4, _toDisplayString(props.titleEnd), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (props.address)
        ? (_openBlock(), _createBlock(SwiperDivLabelAndValueDiv, {
            key: 0,
            label: "Adresse",
            value: props.address
          }, null, 8, ["value"]))
        : _createCommentVNode("", true),
      (props.city)
        ? (_openBlock(), _createBlock(SwiperDivLabelAndValueDiv, {
            key: 1,
            label: "Stadt",
            value: props.city
          }, null, 8, ["value"]))
        : _createCommentVNode("", true),
      (props.phone)
        ? (_openBlock(), _createBlock(SwiperDivLabelAndValueDiv, {
            key: 2,
            label: "Tel",
            value: props.phone
          }, null, 8, ["value"]))
        : _createCommentVNode("", true),
      (props.mobilePhone)
        ? (_openBlock(), _createBlock(SwiperDivLabelAndValueDiv, {
            key: 3,
            label: "Handy",
            value: props.mobilePhone
          }, null, 8, ["value"]))
        : _createCommentVNode("", true),
      (props.email)
        ? (_openBlock(), _createBlock(SwiperDivLabelAndValueDiv, {
            key: 4,
            label: "E-Mail",
            value: props.email
          }, null, 8, ["value"]))
        : _createCommentVNode("", true),
      (props.fax)
        ? (_openBlock(), _createBlock(SwiperDivLabelAndValueDiv, {
            key: 5,
            label: "Fax",
            value: props.fax
          }, null, 8, ["value"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})